<template>
  <div>
    <div id="searcher">
      <div class="wrapper">
        <div class="search-box">
          <div class="search-text">
            <h2>轻便研究 企业导航</h2>
          </div>
          <el-input placeholder="请输入检索词"
                    v-model="searchInput"
                    class="search-input"
                    @keyup.enter.native="handleSearch">
            <el-button class="search-input_button"
                       slot="append"
                       @click="handleSearch">检索</el-button>
          </el-input>
        </div>
      </div>
    </div>
    <div id="body">
      <div class="wrapper">
        <div :class="
            searchFilterShow ? 'search-filter filter-show' : 'search-filter'">
          <div class="filter-op"
               @click="searchFilterShow = !searchFilterShow">检索筛选 <i class="el-icon-arrow-up"></i></div>
          <el-form label-width="8.0em">
            <el-form-item>
              <div slot="label">
                <img src="~@/assets/images/icon-f-type.png"
                     alt="" />所属地区
              </div>
              <el-button class="fitler-more-button"
                         type="text"
                         @click="filterRegionShowAll = !filterRegionShowAll">
                更多
                <i class="el-icon-arrow-up"
                   v-if="filterRegionShowAll"></i>
                <i class="el-icon-arrow-down"
                   v-else></i>
              </el-button>
              <el-checkbox-group v-model="filterRegion"
                                 @change="filterRegionChange"
                                 :class="filterRegionShowAll ? 'show-all' : ''"
                                 :style="filterRegionShowAll ? '' : 'max-height: 32px;'">
                <el-checkbox v-for="(item, index) in compnayRegionList"
                             :key="index"
                             :label="item">
                  {{ item }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>

            <el-form-item>
              <div slot="label">
                <img src="~@/assets/images/icon-f-class.png"
                     alt="" />行业分类
              </div>
              <el-checkbox-group v-model="filterIndustry"
                                 @change="filterIndustryChange">
                <el-checkbox v-for="(item, index) in compnayIndustryList"
                             :key="index"
                             :label="item">
                  {{ item }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <section>
        <div class="ibox">
          <div class="ibox_content">
            <div class="guid-tabs_content show-more">
              <div class="guid-content">
                <div class="guid-organ-list">
                  <el-skeleton :loading="companyLoading"
                               :count="20"
                               animated>
                    <template slot="template">
                      <dl>
                        <dd class="pic">
                          <el-skeleton-item variant="image"
                                            style="width: 45px" />
                        </dd>
                        <dt class="name">
                          <el-skeleton-item variant="h2"
                                            style="width: 80%" />

                        </dt>
                        <dd class="point">
                          <el-skeleton-item variant="text"
                                            style="width:20%; " />
                          <el-skeleton-item variant="text"
                                            style="width:30%; margin-left: 10px; " />
                        </dd>

                      </dl>
                    </template>
                    <template>

                      <dl v-for="item in companyList"
                          :key="item.id">
                        <dd class="pic">
                          <!-- <img :src="item.logoImgUrl" :alt="item.name" /> -->
                          <router-link :to="'/company/detail?id=' + item.id">
                            <el-image :src="item.logoImgUrl">
                              <div slot="error"
                                   class="image-slot">
                                <i class="el-icon-picture-outline"></i>
                              </div>
                            </el-image>
                          </router-link>
                        </dd>
                        <dt class="name">
                          <router-link :to="'/company/detail?id=' + item.id">
                            {{ item.name }}
                          </router-link>
                        </dt>

                        <dd class="point">
                          <span v-if="item.region"
                                :title="item.region">{{
                        item.region
                      }}</span>
                          <span v-if="item.industry"
                                :title="item.industry">{{
                        item.industry
                      }}</span>
                        </dd>
                      </dl>
                    </template>
                  </el-skeleton>

                </div>
                <div class="search-bottom">
                  <div class="search-page-total">
                    共 {{ total > 10000 ? "10000+" : total }} 条 第
                    {{ pageIndex }}/{{
                      pageCount > 1000 ? "1000+" : pageCount
                    }}页
                  </div>
                  <div class="search-page">
                    <el-pagination :current-page="pageIndex"
                                   :page-size="pageSize"
                                   layout=" prev,pager,next,jumper"
                                   :total="total"
                                   @current-change="handleCurrentPageChange">
                    </el-pagination>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { axiosOptions, axiosRequest } from "../../util/request";
import moment from "moment";
import { cutstr } from "../../util/utils";

export default {
  data () {
    return {
      searchFilterShow: false,
      searchInput: "",
      searchSelect: "",
      filterRegion: [],
      filterRegionShowAll: false,
      compnayRegionList: [
        "北京市",
        "天津市",
        "河北省",
        "山西省",
        "内蒙古自治区",
        "辽宁省",
        "吉林省",
        "黑龙江省",
        "上海市",
        "江苏省",
        "浙江省",
        "安徽省",
        "福建省",
        "江西省",
        "山东省",
        "河南省",
        "湖北省",
        "湖南省",
        "广东省",
        "广西壮族自治区",
        "海南省",
        "重庆市",
        "四川省",
        "贵州省",
        "云南省",
        "西藏自治区",
        "陕西省",
        "甘肃省",
        "青海省",
        "宁夏回族自治区",
        "新疆维吾尔自治区",
      ],
      filterIndustry: [],
      compnayIndustryList: [
        "信息技术",
        "食品消费",
        "生命健康",
        "传媒娱乐",
        "先进制造",
        "节能环保",
        "地产金融",
        "传统产业",
      ],
      companyList: [],
      companyLoading: false,
      pageIndex: 1,
      pageSize: 20,
      total: 0,
      pageCount: 0,
    };
  },
  created () {
    this.handleSearch();
  },
  mounted () { },
  methods: {
    filterRegionChange () {
      if (this.filterRegion && this.filterRegion.length > 0) {
        this.filterRegion = this.filterRegion.splice(
          this.filterRegion.length - 1,
          1
        );
      }
      this.getPagedList(true);
    },
    filterIndustryChange () {
      if (this.filterIndustry && this.filterIndustry.length > 0) {
        this.filterIndustry = this.filterIndustry.splice(
          this.filterIndustry.length - 1,
          1
        );
      }
      this.getPagedList(true);
    },
    handleCurrentPageChange (currentPage) {
      this.pageIndex = currentPage;
      this.getPagedList(false);
    },
    handleSearch () {
      this.getPagedList(true);
    },
    getPagedList (resetPageIndex) {
      if (resetPageIndex) {
        this.pageIndex = 1;
      }

      this.companyLoading = true;
      axiosRequest(
        "/company/paged-list",
        {
          tab:
            this.filterIndustry && this.filterIndustry.length > 0
              ? this.filterIndustry[0]
              : "",
          region:
            this.filterRegion && this.filterRegion.length > 0
              ? this.filterRegion[0]
              : "",
          name: this.searchInput,
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
        },
        axiosOptions("post", "", "json")
      )
        .then((res) => {
          this.companyLoading = false;
          if (res.data && res.data.code === 200) {
            this.companyList = res.data.data.records;
            this.total = res.data.data.total;
            this.pageCount = res.data.data.pages;
          }
        })
        .catch(() => {
          this.companyLoading = false;
        });
    },
    cutstring (str, len) {
      return cutstr(str, len);
    },
    dateFormat (cellValue) {
      if (!cellValue) return "";
      // return moment(cellValue).format("YYYY-MM-DD HH:mm:ss");
      return moment(cellValue).format("YYYY-MM-DD");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/var.scss";
@import "@/assets/css/web.scss";
@import "@/assets/css/search.scss";

.guid-tabs {
  &_content {
    max-height: inherit;
    min-height: inherit;
    padding: 20px 0;
    &:after {
      display: none;
    }
  }
}
.guid-content {
  max-height: inherit;
  min-height: inherit;
  .guid-class-list {
    width: 100%;
    height: auto;
    margin-left: 0;
    .guid-info {
      position: relative;
      left: 0;
      top: 0;
      float: left;
      width: 25%;
      height: 342px;
    }
    dl {
      position: relative;
      width: calc(100% / 4);
      vertical-align: top;
    }
  }

  .search-bottom {
    margin-top: 20px;
    margin-bottom: 0;
    font-size: 14px;
    @media screen and (max-width: 768px) {
      padding: 0 15px;
    }
    ::v-deep .el-pagination {
      .el-pagination__total:before {
        background-color: #c9e4ed;
      }
      .el-pager li {
        display: inline-block;
      }
      .el-pager li.active {
        margin-left: 5px !important;
      }
    }
  }
}
</style>
